import { enGB_menu } from './menu'
import { enGB_system } from './sys'
import { enGB_crm_lead } from './crm/lead'
import { enGB_wecom } from './wecom'

const en_GB = {
	...enGB_menu,
	...enGB_system,
	...enGB_crm_lead,
	...enGB_wecom
}

export default en_GB
